import React from 'react';

// import styled components
import { StateContainer } from './styled';

// import svg components
import {
  Ak,
  Al,
  Ar,
  Az,
  Ca,
  Co,
  Ct,
  De,
  Fl,
  Ga,
  Hi,
  Ia,
  Id,
  Il,
  In,
  Ks,
  Ky,
  La,
  Ma,
  Md,
  Mi,
  Mn,
  Mo,
  Ms,
  Mt,
  Nc,
  Nd,
  Ne,
  Nh,
  Nj,
  Nm,
  Nv,
  Ny,
  Oh,
  Ok,
  Or,
  Pa,
  Pr,
  Ri,
  Sc,
  Sd,
  Tn,
  Tx,
  Ut,
  Va,
  Vt,
  Wa,
  Wi,
  Wv,
  Wy,
} from './svg';

const stateList = {
  ak: Ak,
  al: Al,
  ar: Ar,
  az: Az,
  ca: Ca,
  co: Co,
  ct: Ct,
  de: De,
  fl: Fl,
  ga: Ga,
  hi: Hi,
  ia: Ia,
  id: Id,
  il: Il,
  in: In,
  ks: Ks,
  ky: Ky,
  la: La,
  ma: Ma,
  md: Md,
  mi: Mi,
  mn: Mn,
  mo: Mo,
  ms: Ms,
  mt: Mt,
  nc: Nc,
  nd: Nd,
  ne: Ne,
  nh: Nh,
  nj: Nj,
  nm: Nm,
  nv: Nv,
  ny: Ny,
  oh: Oh,
  ok: Ok,
  or: Or,
  pa: Pa,
  pr: Pr,
  ri: Ri,
  sc: Sc,
  sd: Sd,
  tn: Tn,
  tx: Tx,
  ut: Ut,
  va: Va,
  vt: Vt,
  wa: Wa,
  wi: Wi,
  wv: Wv,
  wy: Wy,
};

const State = ({ state }) => {
  const StateName = stateList[state];

  return (
    <StateContainer>
      <StateName />
    </StateContainer>
  );
};

export default State;
